import script from "./AppConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConfirm.vue?vue&type=script&setup=true&lang=js"

import "./AppConfirm.vue?vue&type=style&index=0&id=3b3cc090&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3cc090"]])

export default __exports__